var map = {
	"./asset-hyperlink.json": 99474,
	"./blockquote.json": 35125,
	"./document.json": 55588,
	"./embedded-asset-block.json": 32041,
	"./embedded-entry-block.json": 2007,
	"./embedded-entry-inline.json": 55147,
	"./embedded-resource-block.json": 13305,
	"./embedded-resource-inline.json": 36306,
	"./entry-hyperlink.json": 80362,
	"./heading-1.json": 5753,
	"./heading-2.json": 24573,
	"./heading-3.json": 58666,
	"./heading-4.json": 55815,
	"./heading-5.json": 40672,
	"./heading-6.json": 89676,
	"./hr.json": 74721,
	"./hyperlink.json": 34976,
	"./list-item.json": 85778,
	"./ordered-list.json": 17858,
	"./paragraph.json": 54197,
	"./resource-hyperlink.json": 31107,
	"./table-cell.json": 21768,
	"./table-header-cell.json": 81917,
	"./table-row.json": 42389,
	"./table.json": 33875,
	"./text.json": 43861,
	"./unordered-list.json": 22105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47992;